import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { catchError } from "rxjs/operators";
import { USER_URL } from "../shared/src/lib/shared";
import { ErrorHandlerService } from "./error-handler.service";

@Injectable({
    providedIn: 'root',
})
export class ProjectService {
    private readonly PROJECT_API = `${USER_URL}/project`;
    constructor(private http: HttpClient, private errorHandler: ErrorHandlerService) { }

    getAllProjects(): Observable<any> {
        return this.http
            .get(`${this.PROJECT_API}/getAll`)
            .pipe(catchError(this.errorHandler.handleError));
    }

    getAllProjectsPaginated(
        pageIndex: number,
        pageSize: number,
        searchFilter?: string
    ): Observable<any> {
        let params = new HttpParams()
            .set('pageIndex', String(pageIndex))
            .set('pageSize', String(pageSize));
        if (searchFilter) {
            params = params.set('searchFilter', searchFilter);
        }
        return this.http
            .get(`${this.PROJECT_API}/getAllPaginated`, { params })
            .pipe(catchError(this.errorHandler.handleError));
    }

    saveProject(project: { id?: number; name: string }): Observable<any> {
        return this.http
            .post(`${this.PROJECT_API}/save`, project)
            .pipe(catchError(this.errorHandler.handleError));
    }

    updateProject(project: { id: number; name: string }): Observable<any> {
        return this.http
            .put(`${this.PROJECT_API}/update`, project)
            .pipe(catchError(this.errorHandler.handleError));
    }

    deleteProject(projectId: number): Observable<any> {
        return this.http
            .delete(`${this.PROJECT_API}/delete/${projectId}`)
            .pipe(catchError(this.errorHandler.handleError));
    }
}
